import {
  Column,
  PAUTInspectionItem,
  PAUTItem,
  PAUTOverview,
  Project,
} from "../../../../utils/models";
import { formatTime } from "../../../../utils/utilities";

import GridItem from "../general/gridItem";
import PDFTablePage from "../../../themed/pdf/pdfTablePage";

import classNames from "../pdf.module.scss";
import Conditional from "../../../common/conditional";

interface PAUTInspectionReportProps {
  projectDetails: Project;
  pautOverview: PAUTOverview;
  pautInspectionItem: PAUTInspectionItem;
  pautItem: PAUTItem;
}

const PAUTInspectionReport = (props: PAUTInspectionReportProps) => {
  return (
    <div className={classNames.pautInspection}>
      <div className="container-fluid overflow-hidden">
        <div className="row">
          <div className="col p-0">
            <div className={classNames.pautInspectionTitle}>JOB DETAILS</div>
          </div>

          <div className="col p-0">
            <div className={classNames.pautInspectionTitle}>
              TEST METHOD DETAILS
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col">
            <GridItem
              title="Client:"
              value={props.projectDetails.organisation.organisationName}
            />
            <GridItem
              title="Project / Vessel:"
              value={props.projectDetails.facility.facilityName}
            />
            <GridItem
              title="Process Type:"
              value={props.pautOverview?.processType}
            />
            <GridItem
              title="Surface Condition:"
              value={props.pautOverview?.surfaceCondition}
            />
            <GridItem
              title="Material Temperature:"
              value={props.pautOverview?.materialTemperature}
            />
            <GridItem title="Contractor:" value="Arridex Nigeria Limited" />
            <GridItem
              title="Testing Method:"
              value={props.pautOverview?.testingMethod}
            />
            <GridItem title="Couplant:" value={props.pautOverview?.couplant} />
          </div>

          <div className="col">
            <GridItem
              title="Equipment Model:"
              value={props.pautOverview?.equipmentModel}
            />
            <GridItem
              title="Equipment Sr No.:"
              value={props.pautOverview?.equipmentSrNo}
            />
            <GridItem
              title="Calibration Date:"
              value={formatTime(
                props.pautOverview?.calibrationDate,
                "YYYY-MM-DD"
              )}
            />
            <GridItem
              title="Calibration Due:"
              value={formatTime(
                props.pautOverview?.calibrationDue,
                "YYYY-MM-DD"
              )}
            />
            <GridItem
              title="Internal / External:"
              value={props.pautOverview?.section}
            />
            <GridItem title="Software:" value={props.pautOverview?.software} />
            <GridItem
              title="Ref.calibration block:"
              value={props.pautOverview?.calibrationBlock}
            />
            <GridItem
              title="Reference Block / Reflector:"
              value={props.pautOverview?.reflector}
            />
          </div>
        </div>
      </div>

      <PDFTablePage data={[props.pautItem ?? {}]} columns={pautColumns} />

      <div className={classNames.pautInspectionHeaderWarning}>
        Inspection Details
      </div>

      <PDFTablePage
        data={[props.pautInspectionItem ?? {}]}
        columns={inspectionDetailsColumns}
      />

      <div className={classNames.pautInspectionHeaderWarning}>Scan Image</div>

      <Conditional isVisible={!!props.pautOverview?.scanImage}>
        <div className={classNames.pautInspectionImage}>
          <img src={props.pautOverview?.scanImage} alt="Scan" />
        </div>
      </Conditional>

      <div className={classNames.pautInspectionRemark}>
        Remark: {props.pautOverview?.remark}
      </div>
    </div>
  );
};

const pautColumns: Column[] = [
  {
    path: "thickness",
    label: "Thickness",
  },
  {
    path: "group",
    label: "Group",
  },
  {
    path: "probeID",
    label: "Probe ID",
  },
  {
    path: "wedge",
    label: "Wedge",
  },
  {
    path: "startElement",
    label: "Start Element",
  },
  {
    path: "lastElement",
    label: "Last Element",
  },
  {
    path: "qty",
    label: "Element Qty",
  },
  {
    path: "angle",
    label: "Angle",
  },
  {
    path: "db",
    label: "dB",
  },
  {
    path: "frequency",
    label: "Freq",
  },
  {
    path: "manufacturer",
    label: "Manufacturer",
  },
];

const inspectionDetailsColumns: Column[] = [
  {
    path: "jointNo",
    label: "Joint Number",
  },
  {
    path: "welderId",
    label: "Welder ID",
  },
  {
    path: "sch",
    label: "SCH",
  },
  {
    path: "dia",
    label: "Dia",
  },
  {
    path: "thickness",
    label: "Thickness",
  },
  {
    path: "scanLength",
    label: "Scan Length",
  },
  {
    path: "start",
    label: "Start",
  },
  {
    path: "end",
    label: "End",
  },
  {
    path: "length",
    label: "Length",
  },
  {
    path: "amplitude",
    label: "Amplitude",
  },
  {
    path: "type",
    label: "Type",
  },
  {
    path: "result",
    label: "Result",
  },
];

export default PAUTInspectionReport;
